"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect } from "react";
import { usePathname } from "next/navigation";
import { AccessDenied } from "@/components/access-denied";
import { DashboardErrorBoundary } from "@/components/dashboard-error-boundary";
import { useAccessDeniedStore } from "@/stores/useAccessDeniedStore";
import { getErrorMessage } from "@/types/problem-detail";
import { cn } from "@/lib/utils";
function getAccessDeniedBackLink(): {
  href: string;
  label: string;
} {
  return {
    href: "/dashboard",
    label: "Back to dashboard"
  };
}
export function DashboardMain(t0) {
  const $ = _c(22);
  const {
    children,
    overflow: t1
  } = t0;
  const overflow = t1 === undefined ? "auto" : t1;
  const pathname = usePathname();
  const showAccessDenied = useAccessDeniedStore(_temp);
  const problemDetail = useAccessDeniedStore(_temp2);
  const pathnameAt403 = useAccessDeniedStore(_temp3);
  const clearAccessDenied = useAccessDeniedStore(_temp4);
  let t2;
  let t3;
  if ($[0] !== clearAccessDenied || $[1] !== pathname || $[2] !== pathnameAt403) {
    t2 = () => {
      if (pathnameAt403 != null && pathname !== pathnameAt403) {
        clearAccessDenied();
      }
    };
    t3 = [pathname, pathnameAt403, clearAccessDenied];
    $[0] = clearAccessDenied;
    $[1] = pathname;
    $[2] = pathnameAt403;
    $[3] = t2;
    $[4] = t3;
  } else {
    t2 = $[3];
    t3 = $[4];
  }
  useEffect(t2, t3);
  const mainOverflowClass = overflow === "hidden" ? "overflow-hidden" : "overflow-y-auto";
  if (showAccessDenied && problemDetail) {
    let t4;
    if ($[5] !== problemDetail) {
      t4 = getErrorMessage({
        problemDetail
      }, "You don't have permission to view this resource.");
      $[5] = problemDetail;
      $[6] = t4;
    } else {
      t4 = $[6];
    }
    const message = t4;
    let t5;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
      t5 = getAccessDeniedBackLink();
      $[7] = t5;
    } else {
      t5 = $[7];
    }
    const {
      href,
      label
    } = t5;
    let t6;
    if ($[8] !== mainOverflowClass) {
      t6 = cn("min-h-0 flex-1 flex flex-col p-4", mainOverflowClass);
      $[8] = mainOverflowClass;
      $[9] = t6;
    } else {
      t6 = $[9];
    }
    let t7;
    if ($[10] !== message) {
      t7 = <AccessDenied message={message} backHref={href} backLabel={label} />;
      $[10] = message;
      $[11] = t7;
    } else {
      t7 = $[11];
    }
    let t8;
    if ($[12] !== t6 || $[13] !== t7) {
      t8 = <main className={t6}>{t7}</main>;
      $[12] = t6;
      $[13] = t7;
      $[14] = t8;
    } else {
      t8 = $[14];
    }
    return t8;
  }
  let t4;
  if ($[15] !== mainOverflowClass) {
    t4 = cn("min-h-0 flex-1", mainOverflowClass);
    $[15] = mainOverflowClass;
    $[16] = t4;
  } else {
    t4 = $[16];
  }
  let t5;
  if ($[17] !== children) {
    t5 = <DashboardErrorBoundary>{children}</DashboardErrorBoundary>;
    $[17] = children;
    $[18] = t5;
  } else {
    t5 = $[18];
  }
  let t6;
  if ($[19] !== t4 || $[20] !== t5) {
    t6 = <main className={t4}>{t5}</main>;
    $[19] = t4;
    $[20] = t5;
    $[21] = t6;
  } else {
    t6 = $[21];
  }
  return t6;
}
function _temp4(s_2) {
  return s_2.clearAccessDenied;
}
function _temp3(s_1) {
  return s_1.pathnameAt403;
}
function _temp2(s_0) {
  return s_0.problemDetail;
}
function _temp(s) {
  return s.showAccessDenied;
}